// Training Programs
export const TRAINING_PROGRAMS = [
  "Đại học chính quy",
  "Đại học chất lượng cao",
  "Đại học tiên tiến",
  "Đại học định hướng ứng dụng",
  "Thạc sĩ",
  "Tiến sĩ",
];

// Faculty and Major data structure - HCMUT Official Data
export const FACULTY_MAJORS_MAP: Record<string, string[]> = {
  "KHOA CƠ KHÍ": [
    "Bảo dưỡng Công nghiệp",
    "Kỹ thuật Cơ khí",
    "Công nghệ Dệt, May",
    "Kỹ thuật Cơ điện tử",
    "Kỹ thuật Dệt",
    "Kỹ thuật Hệ thống Công nghiệp",
    "Logistics và Quản lý Chuỗi cung ứng",
    "Kỹ thuật Nhiệt"
  ],
  "KHOA KỸ THUẬT ĐỊA CHẤT VÀ DẦU KHÍ": [
    "Kỹ thuật Địa chất",
    "Kỹ thuật Dầu khí",
    "Địa Kỹ thuật Xây dựng"
  ],
  "KHOA ĐIỆN - ĐIỆN TỬ": [
    "Kỹ thuật Điều khiển và Tự động hóa",
    "Kỹ thuật Điện tử - Viễn thông",
    "Kỹ thuật Điện",
    "Thiết kế vi mạch"
  ],
  "KHOA KỸ THUẬT GIAO THÔNG": [
    "Kỹ thuật Hàng không",
    "Kỹ thuật Ô tô",
    "Kỹ thuật Tàu thủy",
    "Song ngành: Kỹ thuật Tàu thủy - Hàng không"
  ],
  "KHOA KỸ THUẬT HÓA HỌC": [
    "Công nghệ Sinh học",
    "Kỹ thuật Hóa học",
    "Công nghệ Thực phẩm"
  ],
  "KHOA MÔI TRƯỜNG VÀ TÀI NGUYÊN": [
    "Kỹ thuật Môi trường",
    "Quản lý Tài nguyên và Môi trường",
    "Kinh tế tài nguyên thiên nhiên"
  ],
  "KHOA KHOA HỌC VÀ KỸ THUẬT MÁY TÍNH": [
    "Khoa học Máy tính",
    "Kỹ thuật máy tính"
  ],
  "KHOA QUẢN LÝ CÔNG NGHIỆP": [
    "Quản lý công nghiệp",
    "Quản trị Kinh doanh"
  ],
  "KHOA KHOA HỌC ỨNG DỤNG": [
    "Cơ Kỹ thuật",
    "Vật lý Kỹ thuật",
    "Khoa học dữ liệu"
  ],
  "KHOA KỸ THUẬT XÂY DỰNG": [
    "Kỹ thuật Công trình biển",
    "Kỹ thuật Cơ sở hạ tầng",
    "Công nghệ Kỹ thuật Vật liệu Xây dựng",
    "Kỹ thuật Xây dựng",
    "Kiến trúc",
    "Kỹ thuật Trắc địa - Bản đồ",
    "Kỹ thuật Xây dựng Công trình Thủy",
    "Kỹ thuật Xây dựng Công trình Giao thông",
    "Kinh tế Xây dựng"
  ],
  "VIỆT PHÁP": [
    "Kỹ thuật Cơ điện tử",
    "Hàng không",
    "Vật liệu Polymer và Composite",
    "Vật liệu và Năng lượng",
    "Viễn thông",
    "Hệ thống năng lượng điện",
    "Kỹ thuật và quản lý nước đô thị",
    "Xây dựng dân dụng - Công nghiệp và Hiệu quả"
  ],
  "CHƯƠNG TRÌNH TIÊN TIẾN": [
    "Vi mạch - Hệ thống phần cứng",
    "Hệ thống Năng lượng",
    "Kỹ thuật Điều khiển và Tự động hoá",
    "Hệ thống Viễn thông"
  ]
};

// Faculty options for dropdown
export const facultyOptions = Object.keys(FACULTY_MAJORS_MAP).sort();

// Legacy structure for backward compatibility (deprecated)
export const FACULTY_STRUCTURE: Record<string, { name: string; majors: string[] }> = {
  CS: {
    name: "Khoa Khoa học và Kỹ thuật Máy tính",
    majors: [
      "Khoa học Máy tính",
      "Kỹ thuật Phần mềm",
      "Hệ thống Thông tin",
      "Kỹ thuật Máy tính",
    ],
  },
  EE: {
    name: "Khoa Điện - Điện tử",
    majors: [
      "Kỹ thuật Điện",
      "Kỹ thuật Điện tử",
      "Tự động hóa",
      "Kỹ thuật Điều khiển",
    ],
  },
  ME: {
    name: "Khoa Cơ khí",
    majors: [
      "Kỹ thuật Cơ khí",
      "Kỹ thuật Cơ điện tử",
      "Kỹ thuật Nhiệt",
      "Công nghệ Vật liệu",
    ],
  },
  CE: {
    name: "Khoa Kỹ thuật Xây dựng",
    majors: [
      "Xây dựng Dân dụng",
      "Xây dựng Công nghiệp",
      "Kỹ thuật Giao thông",
      "Kỹ thuật Môi trường",
    ],
  },
  CHEM: {
    name: "Khoa Kỹ thuật Hóa học",
    majors: [
      "Kỹ thuật Hóa học",
      "Công nghệ Thực phẩm",
      "Công nghệ Môi trường",
    ],
  },
};
